import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";

export default ({ isOpen, onClose }) => (
  <Dialog open={isOpen}>
    <DialogTitle>Grading Preference</DialogTitle>
    <DialogContent>
      <Typography>
        Please select your grading preference. Note that selecting a card for{" "}
        <Link to="/evaluate" target="_blank">
          evaluation
        </Link>{" "}
        will waive grading fees.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button color="primary" variant="outlined" onClick={onClose}>
        Ok
      </Button>
    </DialogActions>
  </Dialog>
);
